import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowUp, ArrowDown } from "lucide-react";

export default function FinanceBar() {
  const [data, setData] = useState({ items: [] });
  useEffect(() => { api.get("/finance").then((r) => setData(r.data || { items: [] })).catch(() => {}); }, []);
  if (!data.enabled || !(data.items || []).length) return null;
  const items = [...(data.items || []), ...(data.items || [])];
  return (
    <div data-testid="finance-bar" className="bg-[#0b0b0d] text-white overflow-hidden border-y border-white/5">
      <div className="max-w-7xl mx-auto flex items-center gap-0 h-10">
        <div className="shrink-0 px-3 bg-[#e11d2a] h-full flex items-center font-bold text-sm tracking-wide">Piyasa</div>
        <div className="flex-1 overflow-hidden relative">
          <div className="flex gap-6 animate-marquee whitespace-nowrap py-2 px-4">
            {items.map((it, i) => {
              const ch = (it.change || "").trim();
              const isUp = ch.startsWith("+");
              const isDown = ch.startsWith("-");
              return (
                <span key={i} className="inline-flex items-center gap-1.5 text-sm">
                  <span className="font-semibold text-white">{it.name}</span>
                  <span className="text-gray-200">{it.value}</span>
                  {ch && (
                    <span className={`inline-flex items-center text-xs ${isUp ? "text-emerald-400" : isDown ? "text-red-400" : "text-gray-300"}`}>
                      {isUp && <ArrowUp className="w-3 h-3" />}
                      {isDown && <ArrowDown className="w-3 h-3" />}
                      {ch}
                    </span>
                  )}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
